import ApiLibrary from "./ApiLibrary";

class Job extends ApiLibrary.Base {
  static className = "Job";

  static define() {}

  salary = () => {
    if (this.isContract) {
      return `${this.salaryMin}/day`;
    }
    if (this.salaryType === "range" && this.salaryMax) {
      return `${this.salaryMin} - ${this.salaryMax}`;
    }
    return this.salaryMin;
  };
}

export default ApiLibrary.createResource(Job);
